export default {
    props: {
        inspection: {

        },

        height: {

        },
    },

    data: () =>({
        data: null,
    }),

    computed: {
        isNewUnit () {
            if (!this.inspection) {
                return false;
            }

            return !this.inspection.unitId;
        },

        isDone () {
            if (!this.inspection || !this.data) {
                return false;
            }

            return this.data.done;
        },

        isProcessDone () {
            if (!this.data || !this.data.status) {
                return false;
            }

            return this.data.status === "PROCESS_DONE";
        }
    }
}